//import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Music from './components/Music';
import Fun from './components/Fun';
import Projects from './components/Projects';
import Robotics from './components/Robotics';
import Experiments from './components/Experiments';
import AnalyticsDashboard from './components/AnalyticsDashboard';
import AnalyticsAuth from './components/AnalyticsAuth';
import analytics, { shouldSuppressAnalyticsSession } from './utils/analytics';
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"
import { useEffect } from 'react';

function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    analytics.trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/music" element={<Music />} />
      <Route path="/fun" element={<Fun />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/robotics" element={<Robotics />} />
      <Route path="/experiments" element={<Experiments />} />
      <Route
        path="/analytics"
        element={
          <AnalyticsAuth>
            <AnalyticsDashboard />
          </AnalyticsAuth>
        }
      />
    </Routes>
  );
}

function AppShell() {
  const location = useLocation();
  const isAnalyticsRoute = location.pathname.startsWith('/analytics');
  const suppressAnalytics = shouldSuppressAnalyticsSession(location.pathname);

  return (
    <>
      <AnalyticsRouteTracker />
      {isAnalyticsRoute ? (
        <AppRoutes />
      ) : (
        <div className='max-w-5xl mx-auto px-4 sm:px-6 lg:px-8'>
          <Navbar />
          <AppRoutes />
        </div>
      )}
      {!suppressAnalytics && <Analytics />}
      <SpeedInsights />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
